import { render } from "./FAQGeneral.vue?vue&type=template&id=5387a397"
import script from "./FAQGeneral.vue?vue&type=script&lang=js"
export * from "./FAQGeneral.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__